<template>
    <select2 :id="uuid" :value="value" v-on:change="$emit('input', $event)" :settings="settings" :options="options"/>
</template>

<script>
export default {
    props: {
        value: {
            required: true
        },
        settings: {
            type: Object,
            default() {
                return {};
            }
        },
        options: {
            type: Array
        }
    },
    data() {
        return {
            uuid: this.$uuid.v4(),
        };
    },
    mounted() {
        // workaround for existing options when using tags
        if (this.settings.multiple && this.settings.tags) {
            if (Array.isArray(this.value)) {
                this.value.forEach((option) => {
                    $('#' + this.uuid).append(new Option(option, option, false, true));
                });
                $('#' + this.uuid).trigger('change');
            }
        }
    },
    methods: {
        addOption(id, text) {
            // already existing?
            if ($('#' + this.uuid).find("option[value='" + id + "']").length) {
                return;
            }
            $('#' + this.uuid).append(new Option(text, id, false, false));
            $('#' + this.uuid).trigger('change');
        }
    },
}
</script>

<style scoped>

</style>
